import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {WebMessagingService} from '@ispm/core/services/web-messaging.service';

@Injectable()
export class PdfService {
  private _blob: Blob;
  private _blobURL: string;
  private sampleBytes: Uint8Array;
  private documentDownloadUrl: string = location.origin + "/document?docUrl=";

  constructor(@Inject(DOCUMENT) private _document: Document, private webMessagingService: WebMessagingService) {
  }

  public convertBase64ToBinary(base64: string):
    Uint8Array {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }

  public printPDF(data: any) {
    this.convertBlob(data, 'application/pdf');
    this.printPDFInChrome(this.blobURL);
  }

  private printPDFInChrome(blobUrl: any) {
    const iframe = this._document.createElement('iframe');
    iframe.setAttribute('id', 'pdfIframe');
    iframe.style.display = 'none';
    iframe.src = blobUrl;
    this._document.body.appendChild(iframe);
    iframe.contentWindow.print();
  }

  public openPDF(file: any, friendlyName: string, fileId: string) {
    this.convertBlob(file.data ? file.data : file.body, 'application/pdf');

    if (this.webMessagingService.isHyperDriveIntegration()) {
      this.openDocumentsDownloadPage(fileId, friendlyName);
    } else {
      return this.openLinkInNewWindow(this.blobURL, friendlyName, "");
    }
    return null;
  }

  public downloadPDF(file: any, friendlyName: string, fileId: string) {
    this.sampleBytes = this.convertBlob(file.data ? file.data : file.body, 'application/pdf');

    if (this.webMessagingService.isHyperDriveIntegration()) {
      this.openDocumentsDownloadPage(fileId, friendlyName);
    } else {
      let url = this.createFileBlobLink([this.sampleBytes]);
      this.openDownloadLink(url, friendlyName);
    }
  }

  public openDocumentsDownloadPage(fileId, fileName) {
    let fileUrl = encodeURIComponent(this.blobURL.replace("blob:", ""));
    let url = this.documentDownloadUrl + fileUrl + "&fileName=" + fileName;
    this.openDownloadLink(url, undefined);
  }

  private convertBlob(data: any, type: string): Uint8Array {
    const base64Data = this.convertBase64ToBinary(data);
    this.blob = new Blob([base64Data], {type: type});
    this.blobURL = window.URL.createObjectURL(this.blob);
    return base64Data;
  }

  private createFileBlobLink(data) {
    const blob = new Blob(data, {type: 'octet/stream'});
    return window.URL.createObjectURL(blob);
  }

  private openLinkInNewWindow(url, friendlyName, windowFeatures) {
    const a = window.open(url, "_blank", windowFeatures);
    a.location.href = url;
    a.document.title = friendlyName;
    return a;
  }

  public openDownloadLink(url, name) {
    const a = this._document.createElement('a');
    this._document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.target = "_blank";
    a.href = url;
    if (name !== undefined)
      a.download = name;

    const clickHandler = (e) => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        e.target.removeEventListener('click', clickHandler);
      }, 150);
    };
    a.addEventListener('click', clickHandler, false);
    a.click();
  }

  get blob(): Blob {
    return this._blob;
  }

  set blob(value: Blob) {
    this._blob = value;
  }

  get blobURL(): string {
    return this._blobURL;
  }

  set blobURL(value: string) {
    this._blobURL = value;
  }
}
